import type {
  SubscriptionPlanDto,
  CurrentSubscriptionDto,
  CreateCheckoutSessionDto,
  CheckoutSessionResponseDto,
  PortalSessionResponseDto,
  SubscriptionUsageDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const subscriptionsApi = {
  /** Plans are filtered server-side by the current account’s audience (inquirer vs supplier). */
  async getPlans(): Promise<SubscriptionPlanDto[]> {
    return API.get<SubscriptionPlanDto[]>('/subscriptions/plans').then((r) => r.data);
  },

  async createCheckoutSession(dto: CreateCheckoutSessionDto): Promise<CheckoutSessionResponseDto> {
    return API.post<CheckoutSessionResponseDto>('/subscriptions/checkout-sessions', dto).then((r) => r.data);
  },

  async getCurrentSubscription(): Promise<CurrentSubscriptionDto> {
    return API.get<CurrentSubscriptionDto>('/subscriptions/current').then((r) => r.data);
  },

  async createPortalSession(): Promise<PortalSessionResponseDto> {
    return API.post<PortalSessionResponseDto>('/subscriptions/portal-sessions').then((r) => r.data);
  },

  /** Current-month LLM budget status (null budget = unlimited). */
  async getUsage(): Promise<SubscriptionUsageDto> {
    return API.get<SubscriptionUsageDto>('/subscriptions/usage').then((r) => r.data);
  },
};
